import { FormSectionHandler } from '../entity.handler';
import { SimCardResponse, SimCardUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    networkName?: string;
    number?: string;
    description?: string;
}

export class SimCardDetailsSectionHandler implements FormSectionHandler<SimCardResponse, EditorValues> {

    type = 'form';
    icon = ICONS.simcard;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'networkName', 'number', 'description'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.SIMCARD.DETAILS.${key}`, values);
    }

    applyUpdate(entity: SimCardResponse, payload: SimCardUpdateRequest): Promise<SimCardResponse> {
        return this.admin.applyUpdate(api => api.entities.updateSimCard(entity.id, payload));
    }

    mapEntityToEditor(entity: SimCardResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: SimCardUpdateRequest, values: EditorValues): Promise<SimCardUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: SimCardResponse): Promise<FormBuilderField[]> {
        return Promise.resolve().then(() => {
            return [
                TextField('name', this.translate('FIELDS.SERIAL_NUMBER'), true, 1, 255),
                TextField('networkName', this.translate('FIELDS.NETWORK'), true, 1, 255),
                TextField('number', this.translate('FIELDS.NUMBER'), true, 1, 255),
                TextField('description', this.translate('FIELDS.DESCRIPTION'), true, 1, 1024),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, ['networkName', 'description'], fields));
    }

}
